import { SxProps } from "@mui/material";

export const sxTitle: SxProps = {
    fontFamily: "UnimedSans-Bold",
    color: '#383838',
    fontWeight: 700
}

